import toast from "react-hot-toast";
import { offerServices } from "../services/offer.service";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useDeleteOffer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: offerServices.deleteOffer,
    onSuccess: () => {
      queryClient.invalidateQueries(["offers"]);
      toast.success("Offer deleted successfully");
    },
    onError: (error) => {
      toast.error(
        error?.response?.data?.message || "Failed to delete offer"
      );
    },
  });
};